<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1">
<p class="halftitle">FLIGHT THROUGH THE AGES</p>
<p class="halftitle1">A 50th Anniversary Tribute to the Guild of Aviation Artists</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Half_title.vue?0dea7cfc